var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vvs-control-wrapper',[_c('button',{staticClass:"next-button",attrs:{"type":"submit"}},[_vm._t("default",[_vm._v(_vm._s(_vm.title))])],2),(_vm.description)?_c('p',{staticClass:"ps"},[_vm._v(_vm._s(_vm.description))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }